<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ $route.params.id ? "Editar Agendamento" : "Adicionar Agendamento" }}
              </div>
            </div>

            <div class="card-body">
              <hr />
              <br />

              <div class="row">
                <div class="col-md-12">
                  <form @submit.prevent="save">
                    <div class="form-row">
                      <div class="form-group col-md-3">
                        <label>
                          <span class="required">*</span> Empresa:
                        </label>

                        <input
                          v-if="isGestorLogged"
                          type="text"
                          class="form-control"
                          :value="loggedCompanyName"
                          readonly
                        />

                        <select
                          v-else
                          class="form-control"
                          v-model="checklistSchedule.company_id"
                          @change="onChangeCompany"
                        >
                          <option :value="null">Selecione</option>
                          <option
                            v-for="company in filteredCompanies"
                            :key="company.id"
                            :value="company.id"
                          >
                            {{ company.name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-3">
                        <label>
                          <span class="required" v-if="!checklistSchedule.usuario_id">*</span> Grupo:
                        </label>

                        <select
                          class="form-control"
                          v-model="checklistSchedule.group_id"
                          @change="onChangeGroup"
                        >
                          <option :value="null">Selecione</option>
                          <option
                            v-for="group in filteredGroups"
                            :key="group.group_id"
                            :value="group.group_id"
                          >
                            {{ group.group_nome }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-3">
                        <label>
                          <span class="required" v-if="!checklistSchedule.group_id">*</span> Usuário Individual:
                        </label>

                        <select
                          class="form-control"
                          v-model="checklistSchedule.usuario_id"
                          @change="onChangeUsuario"
                        >
                          <option :value="null">Selecione</option>
                          <option
                            v-for="usuario in filteredUsuarios"
                            :key="usuario.usuario_id"
                            :value="usuario.usuario_id"
                          >
                            {{ usuario.usuario_nome }}
                          </option>
                        </select>
                        <small class="form-text text-muted">
                          Preencha o Grupo OU o Usuário Individual
                        </small>
                      </div>

                      <div class="form-group col-md-6">
                        <label>
                          <span class="required">*</span> Checklist:
                        </label>

                        <select
                          class="form-control"
                          v-model="checklistSchedule.checklist_template_id"
                        >
                          <option :value="null">Selecione</option>
                          <option
                            v-for="template in filteredChecklistTemplates"
                            :key="template.checklist_template_id"
                            :value="template.checklist_template_id"
                          >
                            {{ template.nome }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-3">
                        <label>
                          <span class="required">*</span> Tipo de Recorrência:
                        </label>

                        <select
                          class="form-control"
                          v-model="checklistSchedule.tipo_recorrencia"
                          @change="onChangeTipoRecorrencia"
                        >
                          <option :value="null">Selecione</option>
                          <option value="daily">Diária</option>
                          <option value="weekly">Semanal</option>
                          <option value="monthly">Mensal</option>
                        </select>
                      </div>

                      <div class="form-group col-md-3">
                        <label>Status</label><br />
                        <toggle-button
                          v-model="statusToggle"
                          color="#15488A"
                          :height="25"
                        />
                        &nbsp;<b>{{ statusToggle ? "Ativo" : "Inativo" }}</b>
                      </div>
                    </div>

                    <hr />

                    <div v-if="checklistSchedule.tipo_recorrencia === 'daily'">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <h5 class="mb-0">Horários Diários</h5>
                        <button
                          type="button"
                          class="btn btn-add btn-sm"
                          @click="addDailyItem"
                        >
                          <i class="fa fa-plus"></i> Adicionar Horário
                        </button>
                      </div>

                      <div
                        class="form-row align-items-end mb-2"
                        v-for="(item, index) in checklistSchedule.items"
                        :key="'daily-' + index"
                      >
                        <div class="form-group col-md-4">
                          <label>Horário</label>
                          <input
                            type="time"
                            class="form-control"
                            v-model="item.hora_execucao"
                            step="1"
                          />
                        </div>

                        <div class="form-group col-md-3">
                          <label>Tempo de Execução (min)</label>
                          <input
                            type="number"
                            min="1"
                            class="form-control"
                            v-model="item.tempo_execucao_minutos"
                          />
                        </div>

                        <div class="form-group col-md-2">
                          <button
                            type="button"
                            class="btn btn-danger"
                            @click="removeItem(index)"
                          >
                            Remover
                          </button>
                        </div>
                      </div>
                    </div>

                    <div v-if="checklistSchedule.tipo_recorrencia === 'weekly'">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <h5 class="mb-0">Horários Semanais</h5>
                        <button
                          type="button"
                          class="btn btn-add btn-sm"
                          @click="addWeeklyItem"
                        >
                          <i class="fa fa-plus"></i> Adicionar Linha
                        </button>
                      </div>

                      <div
                        class="form-row align-items-end mb-2"
                        v-for="(item, index) in checklistSchedule.items"
                        :key="'weekly-' + index"
                      >
                        <div class="form-group col-md-3">
                          <label>Dia da Semana</label>
                          <select class="form-control" v-model="item.dia_semana">
                            <option :value="null">Selecione</option>
                            <option :value="0">Domingo</option>
                            <option :value="1">Segunda</option>
                            <option :value="2">Terça</option>
                            <option :value="3">Quarta</option>
                            <option :value="4">Quinta</option>
                            <option :value="5">Sexta</option>
                            <option :value="6">Sábado</option>
                          </select>
                        </div>

                        <div class="form-group col-md-3">
                          <label>Horário</label>
                          <input
                            type="time"
                            class="form-control"
                            v-model="item.hora_execucao"
                            step="1"
                          />
                        </div>

                        <div class="form-group col-md-3">
                          <label>Tempo de Execução (min)</label>
                          <input
                            type="number"
                            min="1"
                            class="form-control"
                            v-model="item.tempo_execucao_minutos"
                          />
                        </div>

                        <div class="form-group col-md-2">
                          <button
                            type="button"
                            class="btn btn-danger"
                            @click="removeItem(index)"
                          >
                            Remover
                          </button>
                        </div>
                      </div>
                    </div>

                    <div v-if="checklistSchedule.tipo_recorrencia === 'monthly'">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <h5 class="mb-0">Horários Mensais</h5>
                        <button
                          type="button"
                          class="btn btn-add btn-sm"
                          @click="addMonthlyItem"
                        >
                          <i class="fa fa-plus"></i> Adicionar Linha
                        </button>
                      </div>

                      <div
                        class="form-row align-items-end mb-2"
                        v-for="(item, index) in checklistSchedule.items"
                        :key="'monthly-' + index"
                      >
                        <div class="form-group col-md-3">
                          <label>Dia do Mês</label>
                          <input
                            type="number"
                            min="1"
                            max="31"
                            class="form-control"
                            v-model="item.dia_mes"
                          />
                        </div>

                        <div class="form-group col-md-3">
                          <label>Horário</label>
                          <input
                            type="time"
                            class="form-control"
                            v-model="item.hora_execucao"
                            step="1"
                          />
                        </div>

                        <div class="form-group col-md-3">
                          <label>Tempo de Execução (min)</label>
                          <input
                            type="number"
                            min="1"
                            class="form-control"
                            v-model="item.tempo_execucao_minutos"
                          />
                        </div>

                        <div class="form-group col-md-2">
                          <button
                            type="button"
                            class="btn btn-danger"
                            @click="removeItem(index)"
                          >
                            Remover
                          </button>
                        </div>
                      </div>
                    </div>

                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>

                    <div class="block text-right">
                      <router-link to="/checklistschedules" class="btn btn-back mr-1">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <button type="submit" class="btn btn-add">
                        Salvar
                        <i class="fa fa-save"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  </div>
</template>

<script>
export default {
  name: "ChecklistScheduleAdd",

  data() {
    return {
      checklistSchedule: {
        company_id: null,
        group_id: null,
        usuario_id: null,
        checklist_template_id: null,
        tipo_recorrencia: null,
        status: "ativo",
        items: [],
      },
      companies: [],
      units: [],
      groups: [],
      groupUnits: [],
      usuarios: [],
      checklistTemplates: [],
      loggedCompanyLabel: "",
      errors: undefined,
    };
  },

  computed: {
    loggedUser() {
      return this.$store.state.auth?.user || this.$store.state.user || null;
    },

    isAdminLogged() {
      return Number(this.loggedUser?.perfil_id) === 1;
    },

    isGestorLogged() {
      return Number(this.loggedUser?.perfil_id) === 6;
    },

    isUsuarioPadraoLogged() {
      return Number(this.loggedUser?.perfil_id) === 2;
    },

    loggedCompanyName() {
      if (this.loggedCompanyLabel) {
        return this.loggedCompanyLabel;
      }

      if (this.loggedUser?.company?.name) {
        return this.loggedUser.company.name;
      }

      const companyId =
        this.checklistSchedule.company_id ||
        this.loggedUser?.company_id ||
        this.loggedUser?.company?.id;

      if (!companyId) {
        return "";
      }

      const company = this.companies.find(
        (company) => Number(company.id) === Number(companyId)
      );

      return company ? company.name : "";
    },

    filteredCompanies() {
      return this.companies;
    },

    filteredGroups() {
      if (!this.checklistSchedule.company_id) {
        return [];
      }

      return this.groups.filter(
        (group) => Number(group.company_id) === Number(this.checklistSchedule.company_id)
      );
    },

    filteredUsuarios() {
      if (!this.checklistSchedule.company_id) {
        return [];
      }

      return this.usuarios.filter(
        (usuario) => Number(usuario.company_id) === Number(this.checklistSchedule.company_id)
      );
    },

    filteredChecklistTemplates() {
      if (!this.checklistSchedule.company_id) {
        return [];
      }

      if (!this.checklistSchedule.group_id && !this.checklistSchedule.usuario_id) {
        return [];
      }

      const templates = this.checklistTemplates.filter(
        (t) => Number(t.company_id) === Number(this.checklistSchedule.company_id)
      );

      if (this.checklistSchedule.group_id && this.groupUnits.length > 0) {
        const groupUnitIds = this.groupUnits.map((u) => Number(u.id));
        return templates.filter(
          (t) =>
            Array.isArray(t.units) &&
            t.units.some((u) => groupUnitIds.includes(Number(u.id)))
        );
      }

      return templates;
    },

    statusToggle: {
      get() {
        return this.checklistSchedule.status === "ativo";
      },
      set(value) {
        this.checklistSchedule.status = value ? "ativo" : "inativo";
      },
    },
  },

  watch: {
    groups(newGroups) {
      if (this.checklistSchedule.group_id && this.groupUnits.length === 0) {
        const group = newGroups.find(
          (g) => Number(g.group_id) === Number(this.checklistSchedule.group_id)
        );
        this.groupUnits = Array.isArray(group?.units) ? group.units : [];
      }
    },
  },

  methods: {
    syncLoggedCompanyName() {
      if (!this.isGestorLogged) {
        return;
      }

      const companyId =
        this.checklistSchedule.company_id ||
        this.loggedUser?.company_id ||
        this.loggedUser?.company?.id;

      if (!companyId) {
        return;
      }

      const company = this.companies.find(
        (company) => Number(company.id) === Number(companyId)
      );

      if (company) {
        this.loggedCompanyLabel = company.name;
      }
    },

    getLoggedUserCompany() {
      if (!this.loggedUser?.usuario_id) {
        this.applyLoggedCompany();
        this.syncLoggedCompanyName();
        return;
      }

      const api = this.$store.state.api + "users/" + this.loggedUser.usuario_id;

      axios
        .get(api)
        .then((response) => {
          const data = Array.isArray(response.data.data)
            ? response.data.data[0]
            : response.data.data;

          if (data && data.company_id) {
            this.checklistSchedule.company_id = Number(data.company_id);
          } else {
            this.applyLoggedCompany();
          }

          if (data?.company?.name) {
            this.loggedCompanyLabel = data.company.name;
          } else {
            this.syncLoggedCompanyName();
          }
        })
        .catch((error) => {
          this.applyLoggedCompany();
          this.syncLoggedCompanyName();
          this.$message(null, error.response?.data || error, "error");
        });
    },

    applyLoggedCompany() {
      if (!this.isGestorLogged || !this.loggedUser) {
        return;
      }

      if (this.loggedUser.company_id) {
        this.checklistSchedule.company_id = Number(this.loggedUser.company_id);
      } else if (this.loggedUser.company && this.loggedUser.company.id) {
        this.checklistSchedule.company_id = Number(this.loggedUser.company.id);
      }

      this.syncLoggedCompanyName();
    },

    onChangeCompany() {
      this.checklistSchedule.group_id = null;
      this.checklistSchedule.usuario_id = null;
      this.checklistSchedule.checklist_template_id = null;
      this.groupUnits = [];
    },

    onChangeGroup() {
      this.checklistSchedule.usuario_id = null;
      this.checklistSchedule.checklist_template_id = null;

      if (this.checklistSchedule.group_id) {
        const group = this.groups.find(
          (g) => Number(g.group_id) === Number(this.checklistSchedule.group_id)
        );
        this.groupUnits = Array.isArray(group?.units) ? group.units : [];
      } else {
        this.groupUnits = [];
      }
    },

    onChangeUsuario() {
      if (this.checklistSchedule.usuario_id) {
        this.checklistSchedule.group_id = null;
        this.groupUnits = [];
      }
    },

    onChangeTipoRecorrencia() {
      this.checklistSchedule.items = [];

      if (this.checklistSchedule.tipo_recorrencia === "daily") {
        this.addDailyItem();
      }

      if (this.checklistSchedule.tipo_recorrencia === "weekly") {
        this.addWeeklyItem();
      }

      if (this.checklistSchedule.tipo_recorrencia === "monthly") {
        this.addMonthlyItem();
      }
    },

    addDailyItem() {
      this.checklistSchedule.items.push({
        checklist_schedule_item_id: null,
        hora_execucao: "",
        dia_semana: null,
        dia_mes: null,
        tempo_execucao_minutos: 60,
      });
    },

    addWeeklyItem() {
      this.checklistSchedule.items.push({
        checklist_schedule_item_id: null,
        hora_execucao: "",
        dia_semana: null,
        dia_mes: null,
        tempo_execucao_minutos: 60,
      });
    },

    addMonthlyItem() {
      this.checklistSchedule.items.push({
        checklist_schedule_item_id: null,
        hora_execucao: "",
        dia_semana: null,
        dia_mes: null,
        tempo_execucao_minutos: 60,
      });
    },

    removeItem(index) {
      this.checklistSchedule.items.splice(index, 1);
    },

    normalizeItemsForSave() {
      return this.checklistSchedule.items.map((item) => {
        return {
          checklist_schedule_item_id: item.checklist_schedule_item_id || null,
          hora_execucao: item.hora_execucao || "",
          tempo_execucao_minutos: item.tempo_execucao_minutos || 60,
          dia_semana:
            this.checklistSchedule.tipo_recorrencia === "weekly"
              ? item.dia_semana
              : null,
          dia_mes:
            this.checklistSchedule.tipo_recorrencia === "monthly"
              ? item.dia_mes
              : null,
        };
      });
    },

    makeFormData() {
      this.applyLoggedCompany();

      let fd = new FormData();

      fd.append("company_id", this.checklistSchedule.company_id || "");
      
      // Enviar apenas um: usuario_id tem prioridade sobre group_id
      if (this.checklistSchedule.usuario_id) {
        fd.append("usuario_id", this.checklistSchedule.usuario_id);
      } else if (this.checklistSchedule.group_id) {
        fd.append("group_id", this.checklistSchedule.group_id);
      }
      
      fd.append(
        "checklist_template_id",
        this.checklistSchedule.checklist_template_id || ""
      );
      fd.append("tipo_recorrencia", this.checklistSchedule.tipo_recorrencia || "");
      fd.append("status", this.checklistSchedule.status || "ativo");

      const items = this.normalizeItemsForSave();

      items.forEach((item, index) => {
        if (item.checklist_schedule_item_id) {
          fd.append(`items[${index}][checklist_schedule_item_id]`, item.checklist_schedule_item_id);
        }
        fd.append(`items[${index}][hora_execucao]`, item.hora_execucao || "");
        fd.append(`items[${index}][tempo_execucao_minutos]`, item.tempo_execucao_minutos || 60);

        if (item.dia_semana !== null && item.dia_semana !== undefined && item.dia_semana !== "") {
          fd.append(`items[${index}][dia_semana]`, item.dia_semana);
        }

        if (item.dia_mes !== null && item.dia_mes !== undefined && item.dia_mes !== "") {
          fd.append(`items[${index}][dia_mes]`, item.dia_mes);
        }
      });

      fd.append("_method", "POST");

      if (this.checklistSchedule.id) {
        fd.append("id", this.checklistSchedule.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },

    save() {
      let api = this.$store.state.api + "checklistschedules";
      let fd = this.makeFormData();

      if (this.checklistSchedule.id) {
        api += "/" + this.checklistSchedule.id;
      }

      axios
        .post(api, fd)
        .then(() => {
          this.$message(
            "Sucesso",
            "Informações guardadas com sucesso",
            "success"
          );
          this.$router.push("/checklistschedules");
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    getChecklistSchedule(id) {
      if (!id || id === "undefined") {
        return;
      }

      const api = this.$store.state.api + "checklistschedules/" + id;

      axios
        .get(api, {
          params: {
            with: ["items", "group", "unit", "checklist_template"],
          },
        })
        .then((response) => {
          const data = Array.isArray(response.data.data)
            ? response.data.data[0]
            : response.data.data;

          if (!data) {
            this.$message("Erro", "Agendamento não encontrado", "error");
            this.$router.push("/checklistschedules");
            return;
          }

          // Garante exclusividade: se usuário está definido, limpa grupo e vice-versa
          const loadedUsuarioId = data.usuario_id ? Number(data.usuario_id) : null;
          const loadedGroupId = !loadedUsuarioId && data.group_id ? Number(data.group_id) : null;

          this.checklistSchedule = {
            ...this.checklistSchedule,
            ...data,
            company_id: data.company_id ? Number(data.company_id) : null,
            group_id: loadedGroupId,
            usuario_id: loadedUsuarioId,
            checklist_template_id: data.checklist_template_id
              ? Number(data.checklist_template_id)
              : null,
            items: Array.isArray(data.items)
              ? data.items.map((item) => ({
                  checklist_schedule_item_id: item.checklist_schedule_item_id || item.id || null,
                  hora_execucao: item.hora_execucao || "",
                  tempo_execucao_minutos: item.tempo_execucao_minutos ? Number(item.tempo_execucao_minutos) : 60,
                  dia_semana:
                    item.dia_semana !== null && item.dia_semana !== undefined
                      ? Number(item.dia_semana)
                      : null,
                  dia_mes:
                    item.dia_mes !== null && item.dia_mes !== undefined
                      ? Number(item.dia_mes)
                      : null,
                }))
              : [],
          };

          if (loadedGroupId) {
            const group = this.groups.find(
              (g) => Number(g.group_id) === loadedGroupId
            );
            this.groupUnits = Array.isArray(group?.units) ? group.units : [];
          }

          if (this.isGestorLogged) {
            this.applyLoggedCompany();
            this.getLoggedUserCompany();
          }
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    getCompanies() {
      const api = this.$store.state.api + "companies?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          this.companies = response.data.data || [];
          this.syncLoggedCompanyName();
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    getUnits() {
      const api = this.$store.state.api + "units?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          this.units = response.data.data || [];
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    getGroups() {
      const api = this.$store.state.api + "groups?paginated=false&status=1";

      axios
        .get(api, { params: { with: ["units"] } })
        .then((response) => {
          this.groups = response.data.data || [];
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    getUsuarios() {
      const api = this.$store.state.api + "users?paginated=false&status=1";

      axios
        .get(api, {
          params: {
            with: ["units"],
          },
        })
        .then((response) => {
          this.usuarios = response.data.data || [];
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    getChecklistTemplates() {
      const api = this.$store.state.api + "checklisttemplates?paginated=false&with[]=units";

      axios
        .get(api)
        .then((response) => {
          this.checklistTemplates = response.data.data || [];
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },
  },

  mounted() {
    if (this.isUsuarioPadraoLogged) {
      this.$message("Erro", "Você não tem permissão para acessar esta tela", "error");
      this.$router.push("/");
      return;
    }

    if (this.isGestorLogged) {
      this.applyLoggedCompany();
    }

    this.getCompanies();
    this.getUnits();
    this.getGroups();
    this.getUsuarios();
    this.getChecklistTemplates();

    if (this.isGestorLogged) {
      this.getLoggedUserCompany();
    }

    const id = this.$route.params.id;
    if (id) {
      this.getChecklistSchedule(id);
    }
  },
};
</script>

<style scoped>
</style>